import type { LiveStore } from 'vue-livestore';
import { tables, events } from '@/livestore/schema.js';
import type { ScheduleTemplate } from '@/domain/schedule-template/ScheduleTemplate.js';

/** Soft-deleted schedule templates are purged for real after this long -- gives Drive/OneDrive
 * sync time to propagate the deletion to other devices before the row is gone for good. */
const SOFT_DELETE_RETENTION_MS = 14 * 24 * 60 * 60 * 1000; // 2 weeks

export function purgeExpiredScheduleTemplates(store: LiveStore): void {
  const cutoff = Date.now() - SOFT_DELETE_RETENTION_MS;
  store
    .query<ScheduleTemplate>(tables.scheduleTemplates.select().where({ is_deleted: 1 }))
    .filter(tpl => tpl.deleted_at != null && tpl.deleted_at < cutoff)
    .forEach(tpl => store.commit(events.scheduleTemplatePurged({ id: tpl.id })));
}
